import { User, UserDetails } from './user.model';

export class UserDeserialize {
  public static toUser = (record: any): User => {
    const user = new User();

    user.id = record.id ?? '';
    user.startDate = record.start_date ?? '';
    user.endDate = record.end_date ?? '';
    user.workingYear = record.working_year ?? '';

    user.details = new UserDetails();
    user.details.badgeNumber = record.data?.badge_number ?? '';
    user.details.email = record.data?.email ?? '';
    user.details.firstName = record.data?.firstName ?? '';
    user.details.lastName = record.data?.lastName ?? '';
    user.details.level = record.data?.level ?? '';
    user.details.role = record.data?.role.toUpperCase();
    user.details.title = record.data?.title ?? '';
    user.details.currentCategorySeniority =
      record.data?.anzianitaCategoriaAttuale;
    user.details.currentLevelSeniority = record.data?.anzianitaLivelloAttuale;
    user.details.recruitmentDate = record.data?.dataAssunzioneInEnac;
    user.details.publicAdministrationSeniority =
      record.data?.anzianitaPubblicaAmministrazione;
    user.details.enabled = record.data?.enabled;

    return user;
  };

  public static toTableUser = (record: any): User => {
    const user = new User();

    user.id = record.id ?? '';
    user.startDate = record.start_date ?? '';
    user.endDate = record.end_date ?? '';
    user.workingYear = record.working_year ?? '';

    user.details = new UserDetails();
    user.details.badgeNumber = record.badge_number ?? '';
    user.details.email = record.email ?? '';
    user.details.firstName = record.firstName ?? '';
    user.details.lastName = record.lastName ?? '';
    user.details.level = record.level ?? '';
    user.details.role = record.role.toUpperCase();
    user.details.title = record.title ?? '';
    user.details.enabled = record.enabled;

    return user;
  };
}
